module.exports = __webpack_public_path__ + "img/gutters.daa22b6d.png";